import { useEffect, useState } from 'react';
import { OPENED_DAY_FLASH_MS } from '../constants/holiday.constants';

export function useIsFlashing(flashKey: string | undefined): boolean {
  const [endedFlashKey, setEndedFlashKey] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (flashKey === undefined) return undefined;
    const timer = window.setTimeout(() => setEndedFlashKey(flashKey), OPENED_DAY_FLASH_MS);
    return () => window.clearTimeout(timer);
  }, [flashKey]);

  return flashKey !== undefined && flashKey !== endedFlashKey;
}
